import Axios from 'axios';
import ApiUtils from './api-utils';

export default {
  envoyerEvaluation: (evaluation) => ApiUtils.responseParser(Axios.post('/web/v1/evualuations', evaluation))

};
